import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';
import { GameLikeCollectionComponent } from './pages/minigame/game-like-collection/game-like-collection.component';
import { GameRecentPlayedComponent } from './pages/minigame/game-recent-played/game-recent-played.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { AuthGuard } from './shared/service/auth.guard';
import { RegionRestrictionGuard } from './shared/service/region-restriction.guard';
import { createPageSeo } from './shared/utils/seo.helpers';

const routes: Routes = [
  //默认跳转首页
  { path: '', redirectTo: window.languageCode, pathMatch: 'full' },

  {
    path: ':languageCode',
    component: BasicLayoutComponent,
    canActivate: [RegionRestrictionGuard],
    canActivateChild: [RegionRestrictionGuard],
    children: [
      //首页 - 不受地區限制保護
      {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
      },
      //用户layout
      {
        path: '',
        component: UserLayoutComponent,
        children: [
          //资产管理 剩一個component
          {
            path: 'wallet',
            canActivateChild: [AuthGuard],
            loadChildren: () => import('./pages/user-asset/user-assets.module').then(m => m.UserAssetsModule),
          },
        ],
      },
      {
        path: '404',
        component: PageNotFoundComponent,
        data: {
          seo: createPageSeo(
            'Page Not Found',
            'The page you are trying to access does not exist. Head back to the PUBS.com lobby to explore more games.',
          ),
        },
      },
      {
        path: 'live-casino',
        loadChildren: () => import('./pages/live-casino/live-casino.module').then(m => m.LiveCasinoModule),
      },
      //小游戏
      {
        path: '',
        loadChildren: () => import('./pages/minigame/minigame.module').then(m => m.MinigameModule),
      },
      //我的收藏
      {
        path: 'favorites',
        component: GameLikeCollectionComponent,
        data: {
          seo: createPageSeo(
            'Favourite Games',
            'Revisit your favourite casino games and pick up where you left off at PUBS.com.',
          ),
        },
      },
      //近期玩过
      {
        path: 'recentPlayed',
        component: GameRecentPlayedComponent,
        data: {
          seo: createPageSeo(
            'Recently Played Games',
            'Find the casino games you played recently and return to the action instantly on PUBS.com.',
          ),
        },
      },
      //第三方全窗口
      {
        path: 'play',
        loadChildren: () => import('./pages/full-play/full-play.module').then(m => m.FullPlayModule),
      },
      //ob彩票
      {
        path: 'lottery',
        loadChildren: () => import('./pages/obLottery/obLottery.module').then(m => m.ObLotteryModule),
      },
      //原创游戏
      { path: 'original', loadChildren: () => import('./orignal/orignal.module').then(m => m.OrignalModule) },
      //红利和优惠 and vip
      {
        path: 'promotions',
        loadChildren: () => import('./pages/dividend-vip/dividend-vip.module').then(m => m.DividendVipModule),
      },

      //偏好设置
      {
        path: 'settings',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
      },
      //偏好设置
      {
        path: 'transactions',
        canActivateChild: [AuthGuard],
        loadChildren: () => import('./pages/wallet-history/wallet-history.module').then(m => m.WalletHistoryModule),
      },
      // 帮助中心
      {
        path: 'help-center',
        loadChildren: () => import('./pages/help-center/help-center.module').then(m => m.HelpCenterModule),
      },
      // 体育首页
      {
        path: 'sports',
        loadChildren: () => import('./pages/sports/sports.module').then(m => m.SportsModule),
      },
      {
        path: 'loyalty',
        loadChildren: () => import('./pages/vip/vip.module').then(m => m.VipModule),
      },
      {
        path: 'dev-component',
        loadChildren: () => import('./pages/dev-component/dev-component.module').then(m => m.DevComponentModule),
      },
      {
        path: 'bonuses',
        canActivate: [AuthGuard],
        // standalone 元件用 loadComponent 即可分包，不需為它包一層 NgModule。
        // 改動前是 `component: BonusesComponent`，靜態 import 使整棵 pages/bonuses
        // （首屏 90 KB）進入 initial bundle，而此頁需登入才能進入。
        loadComponent: () => import('./pages/bonuses/bonuses.component').then(m => m.BonusesComponent),
        data: {
          seo: createPageSeo(
            'Active Bonuses',
            'Track your active bonuses, wagering progress, and upcoming rewards tailored to your PUBS.com account.',
          ),
        },
      },
      // 活动
      {
        path: 'activity',
        loadChildren: () => import('./pages/activity/activity.module').then(m => m.ActivityModule),
      },
    ],
  },

  //默认跳转404页面
  { path: '**', redirectTo: window.languageCode + '/404', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true, paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
